import { VaultFormPage } from "@snap-mobile/vault";
import React from "react";

type FormPageProps = {
  visible: boolean;
  children: React.ReactNode | React.ReactNode;
};

export default function FormPage({ visible, children }: FormPageProps) {
  return (
    <VaultFormPage visible={visible}>
      {/* additional container styling and classes here */}
      <div className="px-2 md:px-0">{children}</div>
    </VaultFormPage>
  );
}
